import React from 'react';
import { ModalInstanceProps } from '../interfaces';
import BasicModalTemplate from '../BasicModalTemplate';
import { ResponseSettings } from '../../../editor/features/configure/panels/sections/SystemMessagesSettingsSection/ResponseSettings/ResponseSettings';
import './BotResponseSettingsModal.pcss';

type Props = ModalInstanceProps;

export const BotResponseSettingsModal = (props: Props) => {
  return (
    <BasicModalTemplate
      className="bot-response-settings-modal"
      withMonkeyBackground={false}
      iconClass="bot-response-settings-modal__close-icon"
    >
      <ResponseSettings
        inSection={false}
        className="bot-response-settings-modal__content"
      />
    </BasicModalTemplate>
  );
};
